import CorporateProduct from '@/creditflowresearch/domain/Product/entities/CorporateProduct';
import { ProductType, ProductAbbreviations } from '@/creditflowresearch/domain/Product/types/ProductType';
import {
  HYC_PRODUCT_ID,
  HYC_ABBREVIATION,
  HYC_TYPE,
} from '@/creditflowresearch/domain/Product/constants';

class HycProduct extends CorporateProduct {
  static readonly PRODUCT_ID: string = HYC_PRODUCT_ID;

  static readonly ABBREVIATION: ProductAbbreviations = HYC_ABBREVIATION;

  static readonly TYPE: ProductType = HYC_TYPE;
}

export default HycProduct;
